export default {
    data() {
        return {
            comment: '',
            user: ''
        }
    },

    created() {

        this.user = this.$getUserinfo();
    },

    methods: {
        send() {
            // console.log(this.$parent)
            if(!this.comment.trim()) {
                this.$message.error('请输入评论内容！');
                return;
            }
            this.$post('api.php/User/userComment',{
                token: this.$getToken(),
                comment_id: this.id,
                content: this.comment,
                type: this.type
            }).then(res => {
                if(res.status == 1) {
                    this.$message.success(res.info);
                    this.comment = '';
                    this.$nextTick(() => {
                        this.$parent.initCommentList()
                    })
                }else {
                    this.$message.info(res.info);
                }
            })
        }
    }
}
